import { Component, Input, OnInit } from '@angular/core';
import { AvailableTemplatesService } from '../available-templates.service';
import { AlertSettingsVariable } from 'src/app/hickory-api';
import { PlaceholderUtilities } from '../placeholder-utilities';
import { AlertModelService } from 'src/app/alert/shared/alert-model';

@Component({
  selector: 'app-templated-input-preview',
  templateUrl: './templated-input-preview.component.html',
  styleUrl: './templated-input-preview.component.scss',
  standalone: false
})
export class TemplatedInputPreviewComponent implements OnInit {
  @Input() text: string = '';
  @Input() warnOnContactPlaceholders: boolean = false;

  displayChips = true;
  useSample = false;
  allVariables: AlertSettingsVariable[] = [];

  get previewHtml(): string {

    return this.text.replace(/{{\s*([^{}]+?)\s*}}/g, (_match, variableName: string) => {
      const trimmedName = variableName.trim();
      const foundVar = this.allVariables.find((item) => {
        return trimmedName == item.placeHolder;
      });

      if (!foundVar) {
        return variableName;
      }

      let chipStyle = '';

      if (this.displayChips) {
        chipStyle = 'chip-style';

        if (this.warnOnContactPlaceholders && (foundVar.source === 'Contact' || foundVar.source === 'CSV')) {
          chipStyle = 'chip-style-warning';
        }
      }

      return `<span class="${chipStyle}">${this.useSample ? foundVar.sampleValue : foundVar.friendlyName}</span>`;
    });
  }

  get textHasPlaceholders(): boolean {
    if (!this.text) {
      return false;
    }

    return PlaceholderUtilities.extractPlaceholders(this.text).length != 0;
  }

  constructor(private readonly placeholderService: AvailableTemplatesService,  private alertModel: AlertModelService) {}

  ngOnInit(): void {
    this.placeholderService.getAvailableTemplates(this.alertModel?.alertTemplate?.id).subscribe((result) => {
      this.allVariables = result.items;
    });
  }

}
